import { useTranslation } from 'react-i18next';

import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';

import { useGetAdminSettings } from '../../../../../queries';
import type { AdminSettingsResponse } from '../../../../types';
import {
  transformAdminSettingsToFormValues,
  transformAdminSettingsToRequestValues
} from '../../../../utils';
import AutomaticRosteringFormContent from './AutomaticRosteringFormContent';
import { SETTINGS_GROUP_NAME } from './constants';
import { automaticRosteringSchema } from './schema';

const AutomaticRostering = () => {
  const { t } = useTranslation('common');

  const { data: groups = [], isFetching } =
    useGetAdminSettings<AdminSettingsResponse>(SETTINGS_GROUP_NAME);

  const { mutate: save, isLoading } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: groups[0]?.groupId,
    invalidateQueryKey: [SETTINGS_GROUP_NAME],
    message: {
      success: t('automaticRostering.putSuccess'),
      error: t('automaticRostering.putError')
    }
  });

  const data = groups[0];

  const submitForm = (formData) => {
    save({
      ...data,
      settings: transformAdminSettingsToRequestValues(formData, data.settings)
    });
  };

  return (
    <AdminSettingsFormWrapper
      submitForm={submitForm}
      schema={automaticRosteringSchema}
      isFetching={isFetching}
      isLoading={isLoading}
      data={transformAdminSettingsToFormValues(data)}
    >
      <AutomaticRosteringFormContent />
    </AdminSettingsFormWrapper>
  );
};

export default AutomaticRostering;
